import { createSvgComponent } from "../../icon/createSvgComponent";
import PencilFill from "@core/__generated__/icon/figma/pencil-fill.svg";
export default createSvgComponent(PencilFill);